import {
  getLiveStreamFilter,
  getNextPageToken,
} from '../../selectors/live-streams/live-streams';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { liveStreamsService } from '../../transport';
import { Project, ProjectInOrganizationId } from '../../types/entities';
import { getSelectedProject } from '../projects/projects.selectors';
import { Dispatch, GetState } from '../redux.types';
import { LiveStreamListFilter } from '../reducers/live-streams/live-streams.reducer';

export const NAMES = {
  SELECT_STREAM: 'SELECT_STREAM',
  LIVE_STREAMS_GET_START: 'LIVE_STREAMS_GET_START',
  LIVE_STREAMS_GET_SUCCESS: 'LIVE_STREAMS_GET_SUCCESS',
  LIVE_STREAMS_GET_ERROR: 'LIVE_STREAMS_GET_ERROR',
  LIVE_STREAMS_GET_MORE_START: 'LIVE_STREAMS_GET_MORE_START',
  LIVE_STREAMS_GET_MORE_SUCCESS: 'LIVE_STREAMS_GET_MORE_SUCCESS',
  LIVE_STREAMS_GET_MORE_ERROR: 'LIVE_STREAMS_GET_MORE_ERROR',
  LIVE_STREAMS_GET_ANALYTICS_START: 'LIVE_STREAMS_GET_ANALYTICS_START',
  LIVE_STREAMS_GET_ANALYTICS_SUCCESS: 'LIVE_STREAMS_GET_ANALYTICS_SUCCESS',
  LIVE_STREAMS_GET_ANALYTICS_ERROR: 'LIVE_STREAMS_GET_ANALYTICS_ERROR',
  LIVE_STREAMS_SET_STATE_FILTER: 'LIVE_STREAMS_SET_STATE_FILTER',
};

export const getLiveStreams =
  ({ organizationId, project }: ProjectInOrganizationId) =>
  (dispatch: Dispatch, getState: GetState) => {
    const filter = getLiveStreamFilter(getState());

    return dispatch({
      types: [
        NAMES.LIVE_STREAMS_GET_START,
        NAMES.LIVE_STREAMS_GET_SUCCESS,
        NAMES.LIVE_STREAMS_GET_ERROR,
      ],
      callApi: () =>
        liveStreamsService.getAllLiveStreams(
          { organizationId, project },
          filter,
        ),
    });
  };

export const getLiveStreamAnalytics =
  (
    { organizationId, project }: ProjectInOrganizationId,
    liveStreamId: string,
  ) =>
  (dispatch: Dispatch, getState: GetState) => {
    return dispatch({
      types: [
        NAMES.LIVE_STREAMS_GET_ANALYTICS_START,
        NAMES.LIVE_STREAMS_GET_ANALYTICS_SUCCESS,
        NAMES.LIVE_STREAMS_GET_ANALYTICS_ERROR,
      ],
      callApi: () =>
        liveStreamsService.getLiveStreamAnalytics(
          { organizationId, project },
          liveStreamId,
        ),
    });
  };

export const loadMoreStreams =
  () => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const organizationId = getSelectedOrganizationId(state) as string;
    const project = getSelectedProject(state) as Project;
    const filter = getLiveStreamFilter(state);

    const nextPageToken = getNextPageToken(state);
    if (nextPageToken) {
      return dispatch({
        types: [
          NAMES.LIVE_STREAMS_GET_MORE_START,
          NAMES.LIVE_STREAMS_GET_MORE_SUCCESS,
          NAMES.LIVE_STREAMS_GET_MORE_ERROR,
        ],
        callApi: () =>
          liveStreamsService.getAllLiveStreams(
            { organizationId, project },
            filter,
            nextPageToken,
          ),
      });
    }
  };

export const filterLiveStreamsByState =
  (filter: LiveStreamListFilter) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    const organizationId = getSelectedOrganizationId(state) as string;
    const project = getSelectedProject(state) as Project;

    dispatch({
      type: NAMES.LIVE_STREAMS_SET_STATE_FILTER,
      payload: filter,
    });

    return dispatch({
      types: [
        NAMES.LIVE_STREAMS_GET_START,
        NAMES.LIVE_STREAMS_GET_SUCCESS,
        NAMES.LIVE_STREAMS_GET_ERROR,
      ],
      callApi: () =>
        liveStreamsService.getAllLiveStreams(
          { organizationId, project },
          filter,
        ),
    });
  };

export const setSelectedId =
  (id: String) => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
      type: NAMES.SELECT_STREAM,
      payload: id,
    });
  };

export const getStreamFrameUrl = async (
  { organizationId, project }: ProjectInOrganizationId,
  streamId: string | null,
): Promise<string> => {
  return liveStreamsService.getStreamFrameUrl(
    { organizationId, project },
    streamId,
  );
};
